document.addEventListener('DOMContentLoaded', () => {
  const indexContentDiv = document.querySelector('.IndexContent');

  if (indexContentDiv) {
    const h2Tags = document.querySelectorAll('.page-content h2');
    const ul = document.createElement('ul');

    h2Tags.forEach((h2, index) => {
      const li = document.createElement('li');
      const anchor = document.createElement('a');
      const h2Id = `h2-${index}`;
      const h2Text = h2.textContent.replace(':', '');

      h2.setAttribute('id', h2Id);
      anchor.textContent = h2Text;
      anchor.setAttribute('href', `#${h2Id}`);
      li.appendChild(anchor);
      ul.appendChild(li);
    });

    indexContentDiv.appendChild(ul);

    indexContentDiv.addEventListener('click', (e) => {
      if (e.target.localName === 'a') {
        e.preventDefault();
        const anchor = e.target.hash;
        const id = anchor.replace('#', '');
        const element = jQuery(`#${id}`);

        window.scroll({
          top: element.offset().top - 50,
          behavior: 'smooth',
        });
      }
    });

    backToTopButton.addEventListener('click', () => {
      window.scroll({
        top: 0,
        behavior: 'smooth',
      });
    });

    window.addEventListener('scroll', () => {
      if (window.scrollY === 0) {
        backToTopButton.setAttribute('style', 'display:none;');
      } else {
        backToTopButton.setAttribute('style', 'display:block;');
      }
    });

    if (window.scrollY === 0) {
      backToTopButton.setAttribute('style', 'display:none;');
    } else {
      backToTopButton.setAttribute('style', 'display:block;');
    }
  }
});
